module.exports = __webpack_public_path__ + "img/step_3.e359596e.png";